import { Flex, Icon, useBreakpointValue, Text } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import { useState, useEffect } from 'react'
import { colors } from '../../theme/cssVariables'
import { useNavigate } from 'react-router-dom'
import { MenuItem } from '.'
import { useLanguagePath } from '../../hooks/useI18nRoute'

const Menu = ({
  activeMenu,
  setActiveMenu,
  onClose,
  menuItems,
  disabled = false,
}: {
  activeMenu: string
  setActiveMenu: (menu: string) => void
  onClose: () => void
  menuItems: MenuItem[]
  disabled?: boolean
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false })
  const navigate = useNavigate()
  const getPath = useLanguagePath()

  const [isClickMenu, setIsClickMenu] = useState(false)

  useEffect(() => {
    if (isMobile && !isClickMenu) {
      setActiveMenu('')
    }
    if (!isMobile && !activeMenu) {
      setActiveMenu('trade-url')
    }
  }, [isMobile, isClickMenu, activeMenu, setActiveMenu])

  const handleMenuClick = (item: MenuItem) => {
    if (disabled) return
    if (item.link) {
      navigate(getPath(item.link))
      onClose()
    } else {
      setActiveMenu(item.id)
      setIsClickMenu(true)
    }
  }
  return (
    <Flex
      direction={'column'}
      gap={1}
      mt={8}
      pt={4}
      borderTop={'1px solid'}
      borderColor={colors.colorB5}
    >
      {menuItems.map((item) => (
        <Flex
          key={item.id}
          p={3}
          cursor="pointer"
          alignItems="center"
          color={
            disabled ? colors.colorB3 : activeMenu === item.id ? colors.colorB7 : colors.colorB1
          }
          bg={disabled ? 'transparent' : activeMenu === item.id ? colors.colorA1 : 'transparent'}
          borderRadius={'none'}
          onClick={() => handleMenuClick(item)}
          _hover={{ bg: disabled ? 'transparent' : colors.colorA1, color: colors.colorB7 }}
          opacity={disabled ? 0.5 : 1}
        >
          <Icon as={item.icon} mr={3} />
          <Text>
            <Trans>{item.label}</Trans>
          </Text>
        </Flex>
      ))}
    </Flex>
  )
}

export default Menu
